import React, {Component} from 'react';
import {connect} from 'react-redux';
import Engineers from '../shared/Engineers';

import {
    fetchContractorPreferences,
    fetchContractorEngineers,
    syncContractorEngineers,
    updateContractorEngineer,
    uploadContractorEngineerDocument,
    deleteContractorEngineerDocument
} from '../../actions';

class EngineersContainer extends Component {
    componentDidMount() {
        const {belongsTo, fetchContractorPreferences} = this.props;
        return fetchContractorPreferences(belongsTo);
    }
    render() {
        const generateUrl = (belongsTo, engineer, doc) => {
            return `/api/contractor/${belongsTo}/engineer/${engineer}/documents/${doc}`;
        };
        return <Engineers {...this.props} generateDocUrl={generateUrl}/>
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        belongsTo: state.me.contractor_id,
        engineers: state.contractor.engineers,
        settings: state.contractor.preferences.data
    }
};

export default connect(mapStateToProps, {
    fetchContractorPreferences,
    fetchEngineers: fetchContractorEngineers,
    syncEngineers: syncContractorEngineers,
    updateEngineer: updateContractorEngineer,
    uploadEngineerDocument: uploadContractorEngineerDocument,
    deleteEngineerDocument: deleteContractorEngineerDocument,
})(EngineersContainer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/contractor/EngineersContainer.js